const argoConfig = window?.ARGO_CONFIG || {};

export const featureFlags = argoConfig?.unifiedReceive || {};

export const argoValues = argoConfig?.argo || {};

export default argoConfig;
